import { getQueryKeys } from "../../helper";

const namespace = "business_transactions";

export default {
  ...getQueryKeys(namespace),
};
